module.exports = __webpack_public_path__ + "img/diy-user.4edab62f.svg";